<template>
  <div class="table-container">
    <perfect-scrollbar  @ps-y-reach-end="getLastOrders" ref="scroll"  @ps-scroll-y="getLastOrders">
  <table>
    <tr class="header-table">
      <th>بازار</th>
      <th class="hide-400">زمان و تاریخ</th>
      <th class="hide-400">سمت</th>
      <th class="hide-768">نوع</th>
      <th class="hide-992">قیمت واحد</th>
      <th class="hide-992">مقدار</th>
      <th class="hide-768">کارمزد</th>
      <th class="hide-400">مبلغ کل</th>
      <th>مقدار پر شده</th>
      <th>وضعیت</th>
    </tr>
          <tr v-for="(item ,index) in transactions" :key="index">
            <td style="text-align: right">  {{item.orderType.includes('BUY')? $coins[item.destinationCoin].persianName +'-'+  $coins[item.sourceCoin].persianName : $coins[item.sourceCoin].persianName +'-'+  $coins[item.destinationCoin].persianName }}

            </td>

            <td class="hide-400" >{{ $G2J(item.createdAtDateTime) }}</td>
            <td class="hide-400"
                :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
              {{ item.orderType.includes('SELL') ? 'فروش' : 'خرید' }}
            </td>
            <td class="hide-768"
                :class="{'red' : item.orderType.includes('SELL'), 'green' : item.orderType.includes('BUY') }">
              {{ $orderType[item.orderType] }}
            </td>
            <td class="hide-992">{{ $toLocal(item.unitPrice, $decimal['TOMAN']) }}</td>
            <td class="hide-992">{{ item.amount.toLocaleString() }}</td>
            <td class="hide-768">{{ state.userInfo.fee }}</td>
            <td class="hide-400">{{ $toLocal(item.wholePrice, $decimal['TOMAN']) }}</td>
<!--            <td class="hide-768" v-if="select === 'openOrders'">{{ item.value.toLocaleString() }}</td>-->
<!--            <td @click="dataTable.splice(index,index+1)"-->
<!--                :style="{'text-align': 'left','padding-left': '15px',cursor:'pointer'}" class="red"-->
<!--                v-if="select === 'openOrders'">لغو سفارش-->
<!--            </td>-->
<td>%{{$toLocal(item.executedPercent,2)}}</td>
            <td :class="{'red' : item.orderStatus.includes('CANCEL'), 'green' : item.orderStatus.includes('FINISH') , 'yellow' : item.orderStatus.includes('EXPIRE') || item.orderStatus.includes('PENDING')   }"
                v-if="select === 'orderHistory'">{{ $orderStat[item.orderStatus] }}
            </td>

<!--            <td class="number" :class="{'red' : item.rivals < 0 , 'green' : item.rivals > 0 }"-->
<!--                v-if="select === 'tradeHistory'">-->
<!--              <span v-if="item.rivals > 0">+</span>-->
<!--              {{ item.rivals }}-->
<!--            </td>-->


          </tr>
  </table>
    </perfect-scrollbar>
  </div>

</template>

<script>
export default {
  name: "orderHistory",
  props:['query'],
  data() {
    return {
      select :'orderHistory',
      marketType:'BITCOIN_TOMAN',
      orderhistoryheader: ['بازار', 'زمان و تاریخ', 'سمت', 'نوع', 'قیمت واحد', 'مقدار', 'کارمزد', 'مبلغ کل', 'مقدار پر شده', 'وضعیت'],
      //orders data table
      transactions: [],
      page:0,
      lastPage:1,
    }
  },
watch:{
  'query'() {
    let query = this.query






    if(!query.descendingDate){
      this.transactions= this.transactions.sort((a,b)=>{ return new Date(a.createdAtDateTime)  - new Date(b.createdAtDateTime)})
    }
    else if(query.descendingDate){
      this.transactions= this.transactions.sort((a,b)=>{ return new Date(b.createdAtDateTime)  - new Date(a.createdAtDateTime)})

    }


if(query.startDate && query.endDate !==''){
  // console.log(new Date(query.startDate) , new Date(query.endDate))

const filteredToDates = this.transactions.filter(
  (record)=>{
    return new Date(record.createdAtDateTime) >= new Date(query.startDate) && new Date(record.createdAtDateTime) <= new Date(query.endDate)
  }
)

console.log(filteredToDates)
}






    if(query.coin.coin == ''){







      return this.transactions
    }
//
    else if(query.coin){

      this.marketType = query.coin[0] + '_' + query.baseCoin










      this.state.loading=true;

      const res = this.$axios.get('/orders/',{
        params:{
          market:this.marketType,
          size:20,
          page:this.page,
          type:'P2P',

        }
      }).then(res=> {
        console.log(res.content)
        // return (this.transactions = res.content})

        if(query.tradeType =='BUY'){

          return  this.transactions = res.content.filter(item=>item.orderType.includes('BUY'))
        }

        else return this.transactions = res.content.filter(item=>item.orderType.includes('SELL'))

      })




      // this.transactions=  this.transactions.filter(transaction => {
      //   return transaction.marketType == query.coin[0] + '_' + quer
      // })



    }










    else return this.transactions
  },
},
  methods: {
    async getLastOrders() {

      if (this.page <= this.lastPage) {
        //for scroll loading
        this.page++ //for scroll loading
        let res = await this.$axios.get('/orders', {
          params: {
            market: this.marketType,
            page: this.page,
            size: 20
          }
        })
    
    console.log(res.content)
        if (res.content)
        this.transactions = res.content;
        this.loading = false
     
     
     
     }
    },
  }
  ,
  mounted() {
    this.getLastOrders()
  }
}
</script>

<style lang="scss" scoped>
.table-container{
  height: 300px;
  overflow-y: scroll;
}
.red{
  color: red;
}
.green{
  color: green;
}
.yellow{
  color: yellow;
}

table {
  table-layout: auto;

  th {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    background-color: #091222;
    text-align: center;

    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }

  td {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    height: 40px;
    text-align: center;

    &:first-child{
      text-align: right !important;
    }

    &:last-child{
      text-align: left !important;
    }
  }

  .header-table {
    height: 65px;
    position: sticky;
    top: 0;

    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }

  .body {
    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }
}

@media (max-width: 992px) {
  .hide-992{
    display:none !important;
  }
}

@media (max-width: 768px) {
  .hide-768{
    display:none !important;
  }
}

@media (max-width: 400px) {
  .hide-400{
    display:none !important;
  }
}
</style>